import React from "react";
import FormSubmissionTable, { ColumnHeader } from "../formSubmissionsDataGrid";

const ACHFormSubmission: React.FC = () => {
  const columnHeaders: ColumnHeader[] = [
    {
      Column_Name: "Submission ID",
      Field_Name: "Submission_ID",
    },
    {
      Column_Name: "User Email",
      Field_Name: "User_Email",
    },
    {
      Column_Name: "Entry Date",
      Field_Name: "Entry_Date",
    },
    {
      Column_Name: "ACH Type",
      Field_Name: "achType",
    },
    {
      Column_Name: "Company Name",
      Field_Name: "nameOfCompany",
    },
    {
      Column_Name: "Group Number",
      Field_Name: "groupNumber",
    },
    {
      Column_Name: "Tax ID",
      Field_Name: "taxId",
    },
    {
      Column_Name: "One Time Amount",
      Field_Name: "oneTimeAmount",
    },
  ];

  return <FormSubmissionTable columnHeaders={columnHeaders} formId={5} formName={"ACH"}></FormSubmissionTable>;
};

export default ACHFormSubmission;
